<template>
  <div>
    <CommonDialog
      :dialog="dialogTerminate"
      :head-text="$t(`projects.terminate`)"
      :content-text="$t(`projects.terminate-dialog`)"
      :confirm-button="{
        text: $t('projects.terminate'),
        icon: 'mdi-trash-can-outline'
      }"
      :on-confirm="terminate"
      :on-cancel="
        () => {
          dialogTerminate = false;
        }
      "
    ></CommonDialog>
    <CommonDialog
      :dialog="dialogCancelTermination"
      :head-text="$t(`projects.cancel-terminate`)"
      :content-text="$t(`projects.cancel-terminate-dialog`)"
      :confirm-button="{
        text: $t('projects.cancel-terminate'),
        icon: 'mdi-delete-restore'
      }"
      :on-confirm="cancelTermination"
      :on-cancel="
        () => {
          dialogCancelTermination = false;
        }
      "
    ></CommonDialog>
    <v-row>
      <v-col cols="12">
        <h2>
          {{ $t(`projects.${isTerminate ? "cancel-terminate" : "terminate"}`) }}
        </h2>
        <p>
          {{
            $t(
              `projects.${
                isTerminate
                  ? `cancel-terminate${isFinal ? "-final" : ""}`
                  : "terminate"
              }-text`,
              { date: $dateTime(finalDate, "long") }
            )
          }}
        </p>
        <v-btn
          v-if="!isTerminate"
          color="primary mr-3"
          v-on:click="dialogTerminate = true"
          :loading="loading"
        >
          <v-icon left>mdi-trash-can-outline</v-icon>
          {{ $t("projects.terminate") }}
        </v-btn>
        <v-btn
          v-if="isTerminate && !isFinal"
          color="primary  mr-3"
          v-on:click="dialogCancelTermination = true"
          :loading="loading"
        >
          <v-icon left>mdi-delete-restore</v-icon>
          {{ $t("projects.cancel-terminate") }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CommonDialog from "../common/dialogs/CommonDialog";
import moment from "moment";
export default {
  name: "TerminateProject",
  props: {},
  components: { CommonDialog },
  data: () => ({
    dialogTerminate: false,
    dialogCancelTermination: false,
    loading: false,
    daysToCancel: 14
  }),
  computed: {
    project() {
      return this.$store.getters["projectStore/getItem"];
    },
    isTerminate() {
      return !!this.project.terminated_at;
    },
    finalDate() {
      return (
        this.isTerminate &&
        moment(this.project.terminated_at).add(this.daysToCancel, "days")
      );
    },
    isFinal() {
      return this.isTerminate && moment().diff(this.finalDate) > 0;
    }
  },
  methods: {
    terminate() {
      this.loading = true;
      this.$store
        .dispatch("projectStore/terminate", {
          params: {
            id: this.$route.params.id
          }
        })
        .finally(() => this.getProject());
      this.dialogTerminate = false;
    },
    cancelTermination() {
      this.loading = true;
      this.$store
        .dispatch("projectStore/cancelTermination", {
          params: {
            id: this.$route.params.id
          }
        })
        .finally(() => this.getProject());

      this.dialogCancelTermination = false;
    },
    getProject() {
      this.$store
        .dispatch("projectStore/get", {
          id: this.$route.params.id,
          options: {
            needReset: false
          }
        })
        .finally(() => (this.loading = false));
    }
  }
};
</script>

<style scoped></style>
